import React from 'react';

const HeadphonesIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(7.000000, 6.000000)'>
        <path d='M9,0 C4,0 0,4 0,9 L0,16 C0,17.6568542 1.34314575,19 3,19 L6,19 L6,11 L2,11 L2,9 C2,5.13400675 5.13400675,2 9,2 C12.8659932,2 16,5.13400675 16,9 L16,11 L12,11 L12,19 L15,19 C16.6568542,19 18,17.6568542 18,16 L18,9 C18,4 13.97,0 9,0 Z' />
      </g>
    </g>
  </svg>
);

export default HeadphonesIcon;
